import { render } from "./PDF.vue?vue&type=template&id=5926caa2"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"

import "./PDF.vue?vue&type=style&index=0&id=5926caa2&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__